import { render, staticRenderFns } from "./IntegralSystem.vue?vue&type=template&id=4f192224&scoped=true"
import script from "./IntegralSystem.vue?vue&type=script&lang=js"
export * from "./IntegralSystem.vue?vue&type=script&lang=js"
import style0 from "./IntegralSystem.vue?vue&type=style&index=0&id=4f192224&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f192224",
  null
  
)

export default component.exports